// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"656":"e7a82ccd","822":"696e8bde","906":"5202e4c9","972":"7d285a07"}[chunkId] + ".chunk.css";
};